import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslate } from 'react-admin';
import { UserModel } from '../../../config/types/models/UserModel';

type IProps = {
  user: UserModel;
};
function UserInfoSection({ user }: IProps) {
  const t = useTranslate();
  return (
    <Box>
      <Typography color='secondary'>{t('customer')}:</Typography>
      <Typography>{`${t('name')}: ${user.name}`}</Typography>
      <Typography>{`${t('email')}: ${user.email}`}</Typography>
      <Typography>{`${t('tel')}  : ${user.telephone}`}</Typography>
      <Typography>{`${t('personalNumber')}: ${
        user.personalNumber
      }`}</Typography>
    </Box>
  );
}

export default UserInfoSection;
